import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';
import loading from '@ms/yammer-web-components/dist/navigation/NavigationSpinner';

const feedLoader = () => import(/* webpackChunkName: "4-page-feed" */ 'components/PageFeed');
const storylineHomeLoader = () =>
  import(/* webpackChunkName: "4-page-storyline-home" */ 'components/PageStorylineHome');
const inboxLoader = () => import(/* webpackChunkName: "4-page-inbox" */ 'components/PageInbox');
const campaignsDashboardLoader = () =>
  import(/* webpackChunkName: "4-page-campaigns-dashboard" */ '../PageCampaignsDashboard');
const campaignsHubLoader = () => import(/* webpackChunkName: "4-page-campaigns-hub" */ '../PageCampaignsHub');
const campaignLoader = () => import(/* webpackChunkName: "4-page-campaign" */ '../PageCampaign');
const legacyRouteConverterLoader = () =>
  import(
    /* webpackChunkName: "4-page-legacyrouteconverter" */ '@ms/yammer-web-components/dist/route/LegacyRouteConverter'
  );
const groupLoader = () => import(/* webpackChunkName: "4-page-group" */ 'components/PageGroup');
const groupInsightsLoader = () =>
  import(/* webpackChunkName: "4-page-group-insights" */ '@ms/yammer-web-components/dist/group/PageGroupInsights');
const threadLoader = () => import(/* webpackChunkName: "4-page-thread" */ 'components/PageThread');
const userLoader = () => import(/* webpackChunkName: "4-page-user" */ 'components/PageUser');
const topicLoader = () => import(/* webpackChunkName: "4-page-topic" */ 'components/PageTopic');
const topicNetworkQuestionLoader = () =>
  import(/* webpackChunkName: "4-page-topic-networkquestion" */ 'components/PageTopicNetworkQuestion');
const topicNetworkQuestionBrowseLoader = () =>
  import(/* webpackChunkName: "4-page-topic-networkquestion-browse" */ 'components/PageTopicNetworkQuestionBrowse');
const usagePolicyLoader = () => import(/* webpackChunkName: "4-page-usagepolicy" */ 'components/PageUsagePolicy');
const liveEventLoader = () => import(/* webpackChunkName: "4-page-liveevent" */ 'components/PageLiveEvent');
const delegationSettingsLoader = () =>
  import(/* webpackChunkName: "4-page-delegation-settings" */ 'components/PageDelegationSettings');
const configureLoader = () => import(/* webpackChunkName: "4-page-configure" */ 'components/PageConfigure');
const searchLoader = () => import(/* webpackChunkName: "4-page-search" */ 'components/PageSearch');
const discoverGroupsLoader = () =>
  import(/* webpackChunkName: "4-page-discover-groups" */ 'components/PageDiscoverGroups');
const questionSearchLoader = () =>
  import(/* webpackChunkName: "4-page-question-search" */ 'components/PageQuestionSearch');

const questionThreadLoader = () =>
  import(/* webpackChunkName: "4-page-question-thread" */ 'components/PageQuestionThread');
const questionsLoader = () => import(/* webpackChunkName: "4-page-questions" */ 'components/PageQuestions');
const leadersDirectoryLoader = () =>
  import(/* webpackChunkName: "4-page-leaders-directory" */ 'components/PageLeadersDirectory');
const leadershipCornerLoader = () =>
  import(/* webpackChunkName: "4-page-leadershipcorner" */ 'components/PageLeadershipCorner');
const leaderDashboardLoader = () =>
  import(
    /* webpackChunkName: "4-page-leader-dashboard" */ '@ms/yammer-web-components/dist/leaderDashboard/PageLeaderDashboard'
  );
const leadersCuratedFeedLoader = () =>
  import(
    /* webpackChunkName: "4-page-leaders-curated-feed" */ '@ms/yammer-web-components/dist/leadersCuratedFeed/PageLeadersCuratedFeedMain'
  );
const insightsLeadersLoader = () =>
  import(
    /* webpackChunkName: "4-page-insights-leaders" */ '@ms/yammer-web-components/dist/insights/PageInsightsLeadersMain'
  );
const insightsQnALoader = () =>
  import(/* webpackChunkName: "4-page-insights-qna" */ '@ms/yammer-web-components/dist/insights/PageInsightsQnAMain');
const insightsCampaignLoader = () =>
  import(
    /* webpackChunkName: "4-page-insights-campaign" */ '@ms/yammer-web-components/dist/insights/PageInsightsCampaign'
  );
const insightsCampaignRouterLoader = () =>
  import(
    /* webpackChunkName: "4-page-insights-campaign-router" */ '@ms/yammer-web-components/dist/insights/PageInsightsCampaignRouter'
  );
const insightsNetworkLoader = () =>
  import(
    /* webpackChunkName: "4-page-insights-network" */ '@ms/yammer-web-components/dist/insights/PageInsightsNetwork'
  );
const storylineAdminSettingsLoader = () =>
  import(/* webpackChunkName: "4-page-storyline-admin-settings" */ 'components/PageStorylineAdminSettingsLifecycle');
const askMeAnythingLoader = () => import(/* webpackChunkName: "4-page-askmeanything" */ 'components/PageAskMeAnything');
const askMeAnythingUserEventsLoader = () =>
  import(/* webpackChunkName: "4-page-askmeanything-user-events" */ 'components/PageAskMeAnythingUserEvents');
const askMeAnythingCommunityEventsLoader = () =>
  import(/* webpackChunkName: "4-page-askmeanything-community-events" */ 'components/PageAskMeAnythingCommunityEvents');
const askMeAnythingLeadersEventsLoader = () =>
  import(/* webpackChunkName: "4-page-askmeanything-leaders-events" */ 'components/PageAskMeAnythingLeadersEvents');
const askMeAnythingEventCreationLoader = () =>
  import(/* webpackChunkName: "4-page-askmeanything-event-creation" */ '../PageAskMeAnythingEventCreation');
const storylineAdminSettingsNotificationLoader = () =>
  import(
    /* webpackChunkName: "4-page-storyline-admin-settings-advanced" */ 'components/PageStorylineAdminAdvancedSettingsLifecycle'
  );
const userAchievementsLoader = () =>
  import(/* webpackChunkName: "4-page-user-achievements" */ 'components/PageUserAchievements');
const adminSettingsLoader = () =>
  import(/* webpackChunkName: "4-page-admin-settings" */ 'components/PageAdminSettings');
const manageAudienceLoader = () =>
  import(/* webpackChunkName: "4-page-manage-audience" */ 'components/PageManageAudience');

export const Feed = lazyLoadOnRender({ loader: feedLoader, loading });
export const StorylineHome = lazyLoadOnRender({ loader: storylineHomeLoader, loading });
export const Inbox = lazyLoadOnRender({ loader: inboxLoader, loading });
export const CampaignsHub = lazyLoadOnRender({ loader: campaignsHubLoader, loading });
export const AdminSettings = lazyLoadOnRender({ loader: adminSettingsLoader, loading });
export const CampaignsDashboard = lazyLoadOnRender({ loader: campaignsDashboardLoader, loading });
export const Campaign = lazyLoadOnRender({ loader: campaignLoader, loading });
export const LegacyRouteConverter = lazyLoadOnRender({ loader: legacyRouteConverterLoader, loading });
export const Group = lazyLoadOnRender({ loader: groupLoader, loading });
export const GroupInsights = lazyLoadOnRender({ loader: groupInsightsLoader, loading });
export const Thread = lazyLoadOnRender({ loader: threadLoader, loading });
export const User = lazyLoadOnRender({ loader: userLoader, loading });
export const Topic = lazyLoadOnRender({ loader: topicLoader, loading });
export const TopicNetworkQuestion = lazyLoadOnRender({ loader: topicNetworkQuestionLoader, loading });
export const TopicNetworkQuestionBrowse = lazyLoadOnRender({ loader: topicNetworkQuestionBrowseLoader, loading });
export const UsagePolicy = lazyLoadOnRender({ loader: usagePolicyLoader, loading });
export const LiveEvent = lazyLoadOnRender({ loader: liveEventLoader, loading });
export const DelegationSettings = lazyLoadOnRender({ loader: delegationSettingsLoader, loading });
export const Configure = lazyLoadOnRender({ loader: configureLoader, loading });
export const Search = lazyLoadOnRender({ loader: searchLoader, loading });
export const DiscoverGroups = lazyLoadOnRender({ loader: discoverGroupsLoader, loading });
export const QuestionSearch = lazyLoadOnRender({ loader: questionSearchLoader, loading });
export const QuestionThread = lazyLoadOnRender({ loader: questionThreadLoader, loading });
export const Questions = lazyLoadOnRender({ loader: questionsLoader, loading });
export const LeadershipCorner = lazyLoadOnRender({ loader: leadershipCornerLoader, loading });
export const LeadersCuratedFeed = lazyLoadOnRender({ loader: leadersCuratedFeedLoader, loading });
export const LeadersDirectory = lazyLoadOnRender({ loader: leadersDirectoryLoader, loading });
export const LeaderDashboard = lazyLoadOnRender({ loader: leaderDashboardLoader, loading });
export const InsightsLeaders = lazyLoadOnRender({ loader: insightsLeadersLoader, loading });
export const InsightsQnA = lazyLoadOnRender({ loader: insightsQnALoader, loading });
export const InsightsCampaign = lazyLoadOnRender({ loader: insightsCampaignLoader, loading });
export const InsightsCampaignRouter = lazyLoadOnRender({ loader: insightsCampaignRouterLoader, loading });
export const InsightsNetwork = lazyLoadOnRender({ loader: insightsNetworkLoader, loading });
export const StorylineAdminSettings = lazyLoadOnRender({ loader: storylineAdminSettingsLoader, loading });
export const AskMeAnything = lazyLoadOnRender({ loader: askMeAnythingLoader, loading });
export const AskMeAnythingUserEvents = lazyLoadOnRender({ loader: askMeAnythingUserEventsLoader, loading });
export const AskMeAnythingCommunityEvents = lazyLoadOnRender({ loader: askMeAnythingCommunityEventsLoader, loading });
export const AskMeAnythingLeadersEvents = lazyLoadOnRender({ loader: askMeAnythingLeadersEventsLoader, loading });
export const AskMeAnythingEventCreation = lazyLoadOnRender({ loader: askMeAnythingEventCreationLoader, loading });
export const StorylineAdminSettingsNotification = lazyLoadOnRender({
  loader: storylineAdminSettingsNotificationLoader,
  loading,
});
export const UserAchievements = lazyLoadOnRender({ loader: userAchievementsLoader, loading });
export const ManageAudience = lazyLoadOnRender({ loader: manageAudienceLoader, loading });
